/**
 * Keep Appstle's storefront script from interfering with the native buy box.
 *
 * The product page renders its own selling-plan selector (snippets/ivb-product-buy.liquid),
 * so two Appstle admin settings must be neutralised on the theme side, regardless of how
 * they are toggled in the Appstle admin:
 *
 *   1. "Subscription widget" — would inject a second selector into the product form.
 *   2. "Add JS Interceptor" — patches XHR/fetch on /cart/add and, when Appstle's own widget
 *      has no selection, STRIPS the `selling_plan` param, so subscriptions silently fall
 *      back to one-time purchases.
 *
 * Appstle's app embed defines `RS.Config` inline and loads its main script with `defer`
 * AFTER this section, so this deferred script runs first and can flip both flags before
 * Appstle initialises. `AppstleSubscriptionWidget.setHidden()` (Appstle's public hook, used
 * by its Bundles app) is the belt-and-braces fallback for the widget.
 * The Appstle app embed itself stays enabled (cart widget, analytics).
 */
(function () {
  var KEY = 'ivb-native-selling-plan-selector';

  function configure() {
    var cfg = window.RS && window.RS.Config;
    if (!cfg) return false;
    cfg.widgetEnabled = false;
    cfg.enableAddJSInterceptor = 'false';
    return true;
  }

  function hide(api) {
    if (api && typeof api.setHidden === 'function') api.setHidden(KEY, true);
  }

  configure();
  hide(window.AppstleSubscriptionWidget);
  window.addEventListener('appstle:subscription-widget:loaded', function (e) {
    configure();
    hide(e.detail && e.detail.api);
  });
})();
